import { Academy as o } from "./academy.js";
import { Bag as r } from "./bag.js";
import { Globe as m } from "./globe.js";
import { GlobeSmall as i } from "./globe-small.js";
import { Section as t } from "./section.js";
import { Topic as p } from "./topic.js";
import { Webinar as f } from "./webinar.js";
import { World as e } from "./world.js";
import { Leaf as a } from "./leaf.js";
import { HandRock as l } from "./hand-rock.js";
import { Airplane as n } from "./airplane.js";
import { Car as d } from "./car.js";
import { Gambling as c } from "./gambling.js";
import { Retail as b } from "./retail.js";
import { FoodAndBeverage as u } from "./food-and-beverage.js";
import { Hotel as N } from "./hotel.js";
import { Hospitality as F } from "./hospitality.js";
import { DownUp as g } from "./down-up.js";
import { Lightning as k } from "./lightning.js";
import { LightningFilled as s } from "./lightning-filled.js";
import { News as h } from "./news.js";
import { Idea as B } from "./idea.js";
import { Discount as C } from "./discount.js";
import { Prize as L } from "./prize.js";
import { Lock as G } from "./lock.js";
import { LockSmall as y } from "./lock-small.js";
import { Unlock as D } from "./unlock.js";
import { Lock5 as H } from "./lock-5.js";
import { Lock4 as P } from "./lock-4.js";
import { Lock3 as S } from "./lock-3.js";
import { Lock2 as T } from "./lock-2.js";
import { Click as A } from "./click.js";
import { Bank as W } from "./bank.js";
import { EmoticonHappy as v } from "./emoticon-happy.js";
import { PieChart as w } from "./pie-chart.js";
import { Diamond as O } from "./diamond.js";
import { Target as R } from "./target.js";
import { Gift as E } from "./gift.js";
import { Antenna as M } from "./antenna.js";
import { GraphDots as x } from "./graph-dots.js";
import { Chip as U } from "./chip.js";
import { Chip2 as V } from "./chip-2.js";
import { PaintRoller as q } from "./paint-roller.js";
import { Number1 as z } from "./number-1.js";
import { Number1Filled as I } from "./number-1-filled.js";
import { Number2 as _ } from "./number-2.js";
import { Number2Filled as j } from "./number-2-filled.js";
import { Number3 as J } from "./number-3.js";
import { Number3Filled as K } from "./number-3-filled.js";
import { Sun as Q } from "./sun.js";
import { Blog as X } from "./blog.js";
import { Book as Y } from "./book.js";
import { CashStack as Z } from "./cash-stack.js";
import { Gym as $ } from "./gym.js";
import { Scalability as oo } from "./scalability.js";
import { Backspace as ro } from "./backspace.js";
import { Tools as mo } from "./tools.js";
import { Hashtag as io } from "./hashtag.js";
import { Gaming as to } from "./gaming.js";
import { RetailOnline as po } from "./retail-online.js";
import { Podcast as fo } from "./podcast.js";
import { Microphone as eo } from "./microphone.js";
import { Weight as ao } from "./weight.js";
import { MarketplaceLaptop as lo } from "./marketplace-laptop.js";
import { PaperBag as no } from "./paper-bag.js";
import { OmnichannelExperiences as co } from "./omnichannel-experiences.js";
import { _4People as bo } from "./4-people.js";
import { BackspaceFilled as uo } from "./backspace-filled.js";
import { BankPayout as No } from "./bank-payout.js";
import { BarChart as Fo } from "./bar-chart.js";
import { BarChartFilled as go } from "./bar-chart-filled.js";
import { CarTopView as ko } from "./car-top-view.js";
import { Cloud as so } from "./cloud.js";
import { Dna as ho } from "./dna.js";
import { Education as Bo } from "./education.js";
import { Food as Co } from "./food.js";
import { FoodAndBeverageFilled as Lo } from "./food-and-beverage-filled.js";
import { Franchisors as Go } from "./franchisors.js";
import { GlobeFilled as yo } from "./globe-filled.js";
import { Headquarter as Do } from "./headquarter.js";
import { NewHelp as Ho } from "./new-help.js";
import { Number4 as Po } from "./number-4.js";
import { Number4Filled as So } from "./number-4-filled.js";
import { Number5 as To } from "./number-5.js";
import { Number5Filled as Ao } from "./number-5-filled.js";
import { Number6 as Wo } from "./number-6.js";
import { Number6Filled as vo } from "./number-6-filled.js";
import { Number7 as wo } from "./number-7.js";
import { Number7Filled as Oo } from "./number-7-filled.js";
import { Number8 as Ro } from "./number-8.js";
import { Number8Filled as Eo } from "./number-8-filled.js";
import { Number9 as Mo } from "./number-9.js";
import { Number9Filled as xo } from "./number-9-filled.js";
import { OnDemandMonitor as Uo } from "./on-demand-monitor.js";
import { ShoppingCart as Vo } from "./shopping-cart.js";
import { TravelBag as qo } from "./travel-bag.js";
import { Types as zo } from "./types.js";
import { WebinarLive as Io } from "./webinar-live.js";
import { WebinarOnDemand as _o } from "./webinar-on-demand.js";
const Em = {
  Academy: o,
  Bag: r,
  Globe: m,
  GlobeSmall: i,
  Section: t,
  Topic: p,
  Webinar: f,
  World: e,
  Leaf: a,
  HandRock: l,
  Airplane: n,
  Car: d,
  Gambling: c,
  Retail: b,
  FoodAndBeverage: u,
  Hotel: N,
  Hospitality: F,
  DownUp: g,
  Lightning: k,
  LightningFilled: s,
  News: h,
  Idea: B,
  Discount: C,
  Prize: L,
  Lock: G,
  LockSmall: y,
  Unlock: D,
  Lock5: H,
  Lock4: P,
  Lock3: S,
  Lock2: T,
  Click: A,
  Bank: W,
  EmoticonHappy: v,
  PieChart: w,
  Diamond: O,
  Target: R,
  Gift: E,
  Antenna: M,
  GraphDots: x,
  Chip: U,
  Chip2: V,
  PaintRoller: q,
  Number1: z,
  Number1Filled: I,
  Number2: _,
  Number2Filled: j,
  Number3: J,
  Number3Filled: K,
  Sun: Q,
  Blog: X,
  Book: Y,
  CashStack: Z,
  Gym: $,
  Scalability: oo,
  Backspace: ro,
  Tools: mo,
  Hashtag: io,
  Gaming: to,
  RetailOnline: po,
  Podcast: fo,
  Microphone: eo,
  Weight: ao,
  MarketplaceLaptop: lo,
  PaperBag: no,
  OmnichannelExperiences: co,
  _4People: bo,
  BackspaceFilled: uo,
  BankPayout: No,
  BarChart: Fo,
  BarChartFilled: go,
  CarTopView: ko,
  Cloud: so,
  Dna: ho,
  Education: Bo,
  Food: Co,
  FoodAndBeverageFilled: Lo,
  Franchisors: Go,
  GlobeFilled: yo,
  Headquarter: Do,
  NewHelp: Ho,
  Number4: Po,
  Number4Filled: So,
  Number5: To,
  Number5Filled: Ao,
  Number6: Wo,
  Number6Filled: vo,
  Number7: wo,
  Number7Filled: Oo,
  Number8: Ro,
  Number8Filled: Eo,
  Number9: Mo,
  Number9Filled: xo,
  OnDemandMonitor: Uo,
  ShoppingCart: Vo,
  TravelBag: qo,
  Types: zo,
  WebinarLive: Io,
  WebinarOnDemand: _o
};
export {
  Em as Various
};
